<template>
  <div class="question-box">
    <component 
      :is="questionTypeComponent" 
      :question="question" 
      :selectedAnswer="selectedAnswer"
      @select-answer="$emit('select-answer', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MultipleChoiceQuestion from './QuestionTypes/MultipleChoiceQuestion.vue';
import FillInTheBlankQuestion from './QuestionTypes/FillInTheBlankQuestion.vue';
import OpenAnswerQuestion from './QuestionTypes/OpenAnswerQuestion.vue';
import MultipleChoiceImageQuestion from './QuestionTypes/MultipleChoiceImageQuestion.vue';
import OpenAnswerNumberQuestion from './QuestionTypes/OpenAnswerNumberQuestion.vue';

const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  selectedAnswer: {
    type: [Number, String, null],
    default: null
  }
});

const emit = defineEmits(['select-answer']);

const questionTypeComponent = computed(() => {
  switch (props.question.type) {
    case 'fill_in_the_blank':
      return FillInTheBlankQuestion;
    case 'open_answer':
      return OpenAnswerQuestion;
    case 'multiple_choice_image':
      return MultipleChoiceImageQuestion;
    case 'open_answer_number':
      return OpenAnswerNumberQuestion;
    case 'multiple_choice':
    default:
      return MultipleChoiceQuestion;
  }
});
</script>
